module.exports = __webpack_public_path__ + "static/img/RKG.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RKG.png
// module id = 8rpO
// module chunks = 0